<template>
  <div class="wrapper">
    <Tabs style="margin-top:10px" @on-click="tabChange" :value="labelMsg">
      <!-- <TabPane label="教师列表" name="teacherList">
        <teacherList ref="teacherList"/>
      </TabPane> -->
      <TabPane label="线上网课列表" name="onlineCourse">
        <onlineCourse ref="onlineCourse" />
      </TabPane>
      <TabPane label="线下课程列表" name="offlineCourse">
        <offlineCourse ref="offlineCourse" />
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
  import teacherList from './teacherList.vue'
  import offlineCourse from './offlinecourse.vue'
  import onlineCourse from './onlinecourse.vue'
  export default {
    components: {
      teacherList,
      offlineCourse,
      onlineCourse
    },
    data() {
      return {
        labelMsg: "onlineCourse",
      }
    },
    computed: {},
    mounted() {
      this.$refs.onlineCourse.getData(1)
    },
    methods: {
      // 切换时初始化数据
      tabChange(name) {
        if (name == 'teacherList') this.$refs.teacherList.getData(1)
        if (name == 'onlineCourse') this.$refs.onlineCourse.getData(1)
        if (name == 'offlineCourse') this.$refs.offlineCourse.getData(1)
      }
    }
  }
</script>
<style scoped lang="less">
  .wrapper {
    width: 100%;
    min-width: 0;
    padding: 0 10px;
  }
</style>
